export default "__VITE_PUBLIC_ASSET__04fcae49__"